// import React, { FC, useEffect, useState } from "react";
// import AnyReactComponent from "components/AnyReactComponent/AnyReactComponent";
// import StayCardH from "components/StayCardH/StayCardH";
// import PropertyCard from "components/listingCardOfProperty/card";

// import GoogleMapReact from "google-map-react";
// import { DEMO_STAY_LISTINGS } from "data/listings";
// import ButtonClose from "shared/ButtonClose/ButtonClose";
// import Checkbox from "shared/Checkbox/Checkbox";
// import Pagination from "shared/Pagination/Pagination";
// import TabFilters from "./TabFilters";
// import Heading2 from "components/Heading/Heading2";
// import PropertyCardH from "components/PropertyCardH/PropertyCardH";
// import { Card, CardContent, Typography, Box } from '@mui/material';
// const DEMO_STAYS = DEMO_STAY_LISTINGS.filter((_, i) => i < 12);

// export interface SectionGridHasMapProps { }

// const SectionGridHasMap: FC<SectionGridHasMapProps> = () => {
//   const [currentHoverID, setCurrentHoverID] = useState<string | number>(-1);
//   const [showFullMapFixed, setShowFullMapFixed] = useState(false);
//   const useIsSmallScreen = (breakpoint = 780) => {
//     const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth < breakpoint);
//     console.log("SssssssssssssSS11111", window.innerWidth)
//     useEffect(() => {
//       const handleResize = () => setIsSmallScreen(window.innerWidth < breakpoint);
//       window.addEventListener('resize', handleResize);

//       return () => window.removeEventListener('resize', handleResize);
//     }, [breakpoint]);

//     return isSmallScreen;
//   };

//   const [isDragging, setIsDragging] = useState(false);
//   const [startY, setStartY] = useState(0);
//   const [currentY, setCurrentY] = useState(0);
//   const [translateY, setTranslateY] = useState(100); // Start hidden
//   const [velocity, setVelocity] = useState(0); // Track the dragging velocity

//   // Handle touch start event
//   const handleTouchStart = (event:any) => {
//     setIsDragging(true);
//     setStartY(event.touches[0].clientY);
//     setVelocity(0); // Reset velocity on new drag
//   };

//   // Handle touch move event
//   const handleTouchMove = (event:any) => {
//     if (!isDragging) return;
//     const touchY = event.touches[0].clientY;
//     const deltaY = touchY - startY;

//     // Gradual movement and restrict upward dragging
//     const newTranslateY = Math.max(translateY + deltaY / 2, 0); // Use deltaY/2 for smoother drag
//     setTranslateY(newTranslateY);
//     setCurrentY(touchY);

//     // Track velocity to determine if it's a fast drag
//     const dragVelocity = (touchY - startY) / (event.timeStamp || 1);
//     setVelocity(dragVelocity);
//   };

//   // Handle touch end event
//   const handleTouchEnd = () => {
//     setIsDragging(false);

//     // Decide if the card should snap up or back down based on drag amount
//     if (translateY < 50 || velocity < -0.5) {
//       setTranslateY(0); // Snap to the top if dragged far enough or dragged quickly
//     } else {
//       setTranslateY(100); // Snap back to the bottom
//     }
//   };
//   const isSmallScreen1 = useIsSmallScreen();
//   return (
//     <div>
//       <div style={{
//         width: "100%", background: "black", backgroundImage: "url(image_2024_10_01T08_55_21_065Z.png)", backgroundSize: "cover",
//         backgroundRepeat: "no-repeat", backgroundAttachment: "fixed"
//       }} className="relative flex min-h-screen">

//         <div
//           className={`xl:flex-grow xl:static xl:block `}
//         // ${
//         //   showFullMapFixed ? "fixed inset-0 z-50" : "hidden"
//         // }
//         >
//           {showFullMapFixed && (
//             <ButtonClose
//               onClick={() => setShowFullMapFixed(false)}
//               className="bg-white absolute z-50 left-3 top-3 shadow-lg rounded-xl w-10 h-10"
//             />
//           )}

//           <div className="mapPosition fixed xl:sticky top-0 xl:top-[88px] left-0 w-full h-full xl:h-[calc(100vh)] rounded-md overflow-hidden">
//             {/* <div className="absolute bottom-5 left-3 lg:bottom-auto lg:top-2.5 lg:left-1/2 transform lg:-translate-x-1/2 py-2 px-4 bg-white dark:bg-neutral-800 shadow-xl z-10 rounded-2xl min-w-max">
//               <Checkbox
//                 className="text-xs xl:text-sm"
//                 name="xx"
//                 label="Search as I move the map"
//               />
//             </div> */}

//             {/* BELLOW IS MY GOOGLE API KEY -- PLEASE DELETE AND TYPE YOUR API KEY */}
//             <GoogleMapReact
//               defaultZoom={12}
//               defaultCenter={DEMO_STAYS[0].map}
//               bootstrapURLKeys={{
//                 key: "AIzaSyAGVJfZMAKYfZ71nzL_v5i3LjTTWnCYwTY",
//               }}
//               yesIWantToUseGoogleMapApiInternals
//               options={{
//                 gestureHandling: 'cooperative',
//                 scrollwheel: true,
//                 fullscreenControl: false,
//                 mapTypeId: 'roadmap',
//               }}
//             >
//               {DEMO_STAYS.map((item) => (
//                 <AnyReactComponent
//                   isSelected={currentHoverID === item.id}
//                   key={item.id}
//                   lat={item.map.lat}
//                   lng={item.map.lng}
//                   listing={item}
//                 />
//               ))}
//             </GoogleMapReact>
//           </div>
//         </div>
//         {/* CARDSSSS */}
//         <div className="z-[3] scro overflow-auto h-screen sticky top-0">
//         {/* <Card className="max-w-md mx-auto shadow-lg">
//       <CardContent className="overflow-auto max-h-64">

//       </CardContent>
//     </Card> */}
//           {isSmallScreen1 ?
//             <>
//               <div className={`boxShadow min-h-screen w-full xl:w-[780px] 2xl:w-[880px] flex-shrink-0 xl:px-8  hidden-card1 ${translateY === 0 ? "visible-card" : ""}`}
//                 style={{
//                   transform: `translateY(${translateY}%)`,
//                   overflow:"auto",
//                 }}
//                 onTouchStart={handleTouchStart}
//                 onTouchMove={handleTouchMove}
//                 onTouchEnd={handleTouchEnd}
//               //  className=" boxShadow min-h-screen w-full xl:w-[780px] 2xl:w-[880px] flex-shrink-0 xl:px-8 "
//               >
//                 <div className="grid grid-cols-1 gap-8">
//                   {DEMO_STAYS.map((item) => (
//                     <div
//                       key={item.id}
//                       onMouseEnter={() => setCurrentHoverID((_) => item.id)}
//                       onMouseLeave={() => setCurrentHoverID((_) => -1)}
//                     >
//                       <PropertyCardH data={item} />
//                     </div>
//                   ))}
//                 </div>
//                 <div className="flex mt-16 justify-center items-center">
//                   <Pagination />
//                 </div>
//               </div>
//             </> :
//             <>
//               <div className="hidden-card" >
//               </div>
//               <div className="boxShadow min-h-screen w-full xl:w-[720px] 2xl:w-[800px] flex-shrink-0">
//                 <div className="z-10 bg-white fixed xl:sticky top-0 xl:top-[60px] xl:px-8 left-0 w-full  xl:h-[calc(100vh-88vh)] rounded-md overflow-hidden mb-8 mt-8 lg:mb-11">
//                   <TabFilters />
//                 </div>
//                 <div className="grid xl:grid-cols-2 grid-cols-1 xl:px-8 gap-8">
//                   {DEMO_STAYS.map((item) => (
//                     <div
//                       key={item.id}
//                       onMouseEnter={() => setCurrentHoverID((_) => item.id)}
//                       onMouseLeave={() => setCurrentHoverID((_) => -1)}
//                     >
//                       <PropertyCard data={item} />
//                     </div>
//                   ))}

//                 </div>
//                 <div className="flex mt-16 mb-8 justify-center items-center">
//                   <Pagination />
//                 </div>
//               </div>
//             </>
//           }
//         </div>

//         {!showFullMapFixed && (
//           <div
//             className="flex xl:hidden items-center justify-center fixed bottom-8 left-1/2 transform -translate-x-1/2 px-6 py-2 bg-neutral-900 text-white shadow-2xl rounded-full z-30  space-x-3 text-sm cursor-pointer"
//             onClick={() => setShowFullMapFixed(true)}
//           >
//             <i className="text-lg las la-map"></i>
//             <span>Show map</span>
//           </div>
//         )}
//       </div>
//     </div>
//   );
// };

// export default SectionGridHasMap;


import React, { FC, useCallback, useEffect, useLayoutEffect, useMemo, useRef, useState } from "react";
import Pagination from '@mui/material/Pagination';
import Stack from '@mui/material/Stack';
import { debounce } from 'lodash';
import StayCardH from "components/StayCardH/StayCardH";
import GoogleMapReact from "google-map-react";
import { DEMO_STAY_LISTINGS } from "data/listings";
import ButtonClose from "shared/ButtonClose/ButtonClose";
import Checkbox from "shared/Checkbox/Checkbox";
import TabFilters from "./TabFilters";
import Heading2 from "components/Heading/Heading2";
import PropertyCardEuropea from "components/PropertyCardEuropea/PropertyCardEuropea";
import { Card, CardContent, Typography, Box } from '@mui/material';
import axios from "axios";
import { useAppContext } from "AppContext";
import CustomPagination from "shared/Pagination/CustomPagination";
import { base_url } from "constant/constant";
import TabFiltersNew from "./TabFilterNew";
import { useLocale } from "i18n/locale";
import Snackbar from '@mui/material/Snackbar';
import MuiAlert, { AlertProps } from '@mui/material/Alert';
import moment from "moment";
import { toFilterDateString } from "utils/filterDates";
import ContactFormModal from "../../shared/Footer/ContactForm";
import arrowUpIcon from "images/card/arrow-up.svg";
import emptyStateIcon from "images/card/empty-state-icon.svg";
import minimizeIcon from "images/filters/minimize.svg";
import MapPropertyCard from "components/MapPropertyCard/MapPropertyCard";
import ClusterPropertyList from "components/MapPropertyCard/ClusterPropertyList";
import { clusterProperties, ClusterItem, getCoords } from "utils/clusterProperties";
import { createPriceMarker, PriceMarkerHandle } from "utils/priceMarkerOverlay";


const DEMO_STAYS = DEMO_STAY_LISTINGS.filter((_, i) => i < 12);

const Alert = React.forwardRef<HTMLDivElement, AlertProps>(function Alert(
  props,
  ref
) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});
export interface SectionGridHasMapProps {
  onPropertyCountChange?: (count: number) => void;
}

declare namespace google {
  namespace maps {
    // Add your specific type declarations here if needed
    export class Map { }
  }
}

interface Coordinates {
  type: 'Point'; // Enforce the 'Point' enum value
  coordinates: [longitude: number, latitude: number]; // Tuple for fixed two-element array
}
interface Amenity {
  name: string;
}
export interface Property {
  _id: string;
  title: string;
  residence_type: string;
  type_of_unit: string;
  status_of_unit: string;
  city: string;
  country: string;
  base_price: number;
  sleeps: number;
  bedrooms: number;
  bathrooms: number;
  createdAt: string;
  updatedAt: string;
  coordinates: Coordinates;
  toilets: any;
  amenities: Amenity[];
  policies: any;
  security_and_safety: string[];
  avgRatePerDay: number;
  // coordinates

}

export interface ApiResponse {
  title: string;
  error: boolean;
  data: Property[];
  total: number;
  page: number;
  pages: number;
}
type FormValues = {
  name: string;
  email: string;
  phone: string;
  message: string;
  isChecked: boolean;
};

interface NeighbourhoodArea {
  name: string;
  lat: number;
  lng: number;
}
interface NeighbourhoodGroup {
  city: string;
  areas: NeighbourhoodArea[];
}

// Neighbourhoods available in the map "Neighborhoods" dropdown, grouped by city.
const NEIGHBOURHOODS: NeighbourhoodGroup[] = [
  {
    city: "Paris",
    areas: [
      { name: "Le Marais", lat: 48.859, lng: 2.361 },
      { name: "Eiffel Tower", lat: 48.8584, lng: 2.2945 },
      { name: "Arc de Triomphe", lat: 48.8738, lng: 2.295 },
      { name: "Latin Quarter", lat: 48.85, lng: 2.347 },
      { name: "Louvre / Opéra", lat: 48.866, lng: 2.335 },
      { name: "Montmartre", lat: 48.8867, lng: 2.3431 },
      // The greater-Paris suburbs (Montreuil, Neuilly-sur-Seine,
      // Boulogne-Billancourt) are deliberately absent. aiSearch.js still treats
      // them as served and maps them to Paris, so "properties in Montreuil"
      // returns Paris results — but they aren't offered as neighbourhoods to
      // browse, and with no coordinates here the nearbyArea effect below falls
      // back to a normal city-wide search instead of focusing the map or
      // labelling the dropdown with the suburb's name.
    ],
  },
  {
    city: "Brussels",
    areas: [
      { name: "Grand-Place / City Centre", lat: 50.8467, lng: 4.3525 },
      { name: "European Quarter", lat: 50.8425, lng: 4.38 },
      { name: "Sablon", lat: 50.8405, lng: 4.356 },
      { name: "Ixelles", lat: 50.827, lng: 4.372 },
      { name: "Atomium / Brussels Expo", lat: 50.8949, lng: 4.3415 },
    ],
  },
];

// Fallback centre point per city (matches fetchProperties centring).
const CITY_CENTERS: Record<string, { lat: number; lng: number }> = {
  Paris: { lat: 48.864716, lng: 2.349014 },
  Brussels: { lat: 50.85034, lng: 4.35171 },
};

// Resolve a neighbourhood's coordinates from its exact name (as returned by the
// AI's `nearbyArea`, kept in lockstep with VALID_NEARBY_AREAS in aiSearch.js).
// Returns null for an unknown name.
const findAreaCoords = (name: string): { lat: number; lng: number } | null => {
  for (const group of NEIGHBOURHOODS) {
    const area = group.areas.find((a) => a.name === name);
    if (area) return { lat: area.lat, lng: area.lng };
  }
  return null;
};


const SectionGridHasMap: FC<SectionGridHasMapProps> = ({ onPropertyCountChange }) => {
  const { t } = useLocale();
  const [currentHoverID, setCurrentHoverID] = useState<string | number>(-1);
  const [showFullMapFixed, setShowFullMapFixed] = useState(false);
  const [mapExpanded, setMapExpanded] = useState(false);
  // Mirrors mapExpanded so the stable (empty-dep) marker/cluster click handlers
  // can read the latest value without being re-created. Used to scroll-to-top
  // ONLY on the first expand, not on every pill click while already expanded.
  const mapExpandedRef = useRef(mapExpanded);
  useEffect(() => {
    mapExpandedRef.current = mapExpanded;
  }, [mapExpanded]);
  const [selectedProperty, setSelectedProperty] = useState<Property | null>(null);
  const [selectedCluster, setSelectedCluster] = useState<ClusterItem | null>(null);
  const [zoomLevel, setZoomLevel] = useState(13);
  const [centerLocation, setCenterLocation] = useState({ "lat": 48.8566, "lng": 2.3522 });
  const [properties, setProperties] = useState<Property[]>([]);
  const [filterproperties, setFilterProperties] = useState<Property[]>([]);
  const [selectedFilters, setSelectedFilters] = useState<string[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const mapRef = useRef<google.maps.Map | null>(null);
  // The Maps API namespace (google.maps), captured on load — needed to build
  // the native price-marker overlays. mapReady flips once both are available.
  const mapsRef = useRef<any>(null);
  const [mapReady, setMapReady] = useState(false);
  // Live registry of native marker overlays, keyed by marker id, so the sync
  // effect can add/remove/update them in place instead of rebuilding.
  const markerOverlaysRef = useRef<globalThis.Map<string, PriceMarkerHandle>>(
    new window.Map()
  );
  const cardRef = useRef<HTMLDivElement | null>(null);
  const [cardHeight, setCardHeight] = useState<number>(0);
  const [rangePrices, setRangePrices] = useState([0, 1000]);
  const [snackbarSeverity, setSnackbarSeverity] = useState<'success' | 'error'>(
    'success'
  );
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [open, setOpen] = useState(false)
  const [neighborhoodsOpen, setNeighborhoodsOpen] = useState(false);
  const [selectedNeighborhood, setSelectedNeighborhood] = useState<string | null>(null);
  const neighborhoodsRef = useRef<HTMLDivElement | null>(null);
  const pendingCenterRef = useRef<{ lat: number; lng: number } | null>(null);
  const [formValues, setFormValues] = useState<FormValues>({
    name: "",
    email: "",
    phone: "",
    message: "",
    isChecked: false
  });
  const useIsSmallScreen = (breakpoint = 780) => {
    const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth < breakpoint);
    useEffect(() => {
      const handleResize = () => setIsSmallScreen(window.innerWidth < breakpoint);
      window.addEventListener('resize', handleResize);

      return () => window.removeEventListener('resize', handleResize);
    }, [breakpoint]);

    return isSmallScreen;
  };
  const smallScreen1 = useIsSmallScreen()

  //   const handleSetCenterLocation = useCallback((lat: number, lng: number) => {
  //     setCenterLocation({ lat, lng });
  // }, []);

  useEffect(() => {
    onPropertyCountChange?.(filterproperties.length);
  }, [filterproperties.length, onPropertyCountChange]);

  useLayoutEffect(() => {
    if (cardRef.current) {
      setCardHeight(cardRef.current.offsetHeight);
    }
  }, [selectedProperty, selectedCluster]);

  const getPaginatedProperties = () => {
    return filterproperties.slice(0, currentPage * 10);
  };

  const mapItems = useMemo(
    // When the map is expanded (wide open) plot every property for the
    // destination; the compact side map keeps the paginated subset so it
    // matches the list of cards next to it.
    () => clusterProperties(mapExpanded ? filterproperties : getPaginatedProperties(), zoomLevel),
    [filterproperties, currentPage, zoomLevel, mapExpanded]
  );

  // Recenter the map imperatively whenever we programmatically change
  // `centerLocation` (marker/cluster click, neighbourhood focus, city switch).
  // The map itself is uncontrolled (no `center` prop), so user panning never
  // triggers a React re-render — which is what stops the price markers from
  // blinking. Because this only runs when *we* set a new centerLocation, it
  // doesn't fight the user's own drags.
  useEffect(() => {
    const map = mapRef.current as any;
    if (map && map.panTo) {
      map.panTo(centerLocation);
    }
  }, [centerLocation]);

  const handleMarkerClick = (markerLat: number, markerLng: number) => {
    const mapBounds = {
      north: centerLocation.lat + 0.05, // Change these values based on zoom level
      south: centerLocation.lat - 0.05,
      east: centerLocation.lng + 0.05,
      west: centerLocation.lng - 0.05,
    };

    let latOffset = 0;
    let lngOffset = 0;

    // Calculate latitude offset based on north/south proximity
    if (markerLat >= mapBounds.north) {
      latOffset = -0.05; // Move down if too close to the north
    } else if (markerLat <= mapBounds.south) {
      latOffset = 0.05; // Move up if too close to the south
    }

    // Calculate longitude offset based on east/west proximity
    if (markerLng >= mapBounds.east) {
      lngOffset = -0.05; // Move left if too close to the east
    } else if (markerLng <= mapBounds.west) {
      lngOffset = 0.05; // Move right if too close to the west
    }

    setCenterLocation({ lat: markerLat + latOffset, lng: markerLng + lngOffset });
  };
  // Wrapped in useCallback (stable identity) so the memoized map markers don't
  // re-render on every parent render (e.g. the per-frame center sync during a
  // drag). Only setState/ref values are used, so an empty dep array is correct.
  const handleSetCenterLocation = useCallback((lat: any, lng: any, property?: any) => {
    let lngOffset = 0.015; // default for zoom ~13
    const map = mapRef.current as any;
    if (map && map.getBounds) {
      const bounds = map.getBounds();
      if (bounds) {
        const visibleLngRange = bounds.getNorthEast().lng() - bounds.getSouthWest().lng();
        lngOffset = visibleLngRange * 0.15;
      }
    }
    setCenterLocation({ lat, lng: lng + lngOffset });
    const wasExpanded = mapExpandedRef.current;
    setMapExpanded(true);
    // Only on the FIRST expand: hiding the tall right-hand list collapses the
    // page, and without this a scrolled-down user is left looking at the bottom
    // of the now-sticky map, so anchor to the top. When the map is ALREADY
    // expanded, don't scroll — otherwise every price-pill click yanks the page
    // back to the top.
    if (!wasExpanded) window.scrollTo({ top: 0 });
    if (property) {
      setSelectedProperty(property);
      setSelectedCluster(null);
    }
  }, []);
  const handleClusterClick = useCallback((cluster: ClusterItem) => {
    const lngOffset = (() => {
      const map = mapRef.current as any;
      if (map && map.getBounds) {
        const bounds = map.getBounds();
        if (bounds) {
          const visibleLngRange = bounds.getNorthEast().lng() - bounds.getSouthWest().lng();
          return visibleLngRange * 0.15;
        }
      }
      return 0.015;
    })();
    setCenterLocation({ lat: cluster.lat, lng: cluster.lng + lngOffset });
    const wasExpanded = mapExpandedRef.current;
    setMapExpanded(true);
    // See handleSetCenterLocation: scroll to top only on the first expand, never
    // on later clicks while the map is already open.
    if (!wasExpanded) window.scrollTo({ top: 0 });
    setSelectedCluster(cluster);
    setSelectedProperty(cluster.properties[0] || null);
  }, []);

  const handleClusterPropertySelect = useCallback((property: Property) => {
    setSelectedProperty(property);
  }, []);

  // Sync the native price-marker overlays with the current mapItems. These are
  // real google.maps.OverlayView instances (see priceMarkerOverlay.ts) so the
  // Maps engine positions them in lockstep with the tiles — no drag jitter.
  // We add/remove only what changed and update hover state in place, so nothing
  // is torn down and rebuilt on a pan or a hover. (Declared after the click
  // handlers so it can reference them without hitting the temporal dead zone.)
  useEffect(() => {
    const map = mapRef.current;
    const maps = mapsRef.current;
    if (!map || !maps) return;

    const registry = markerOverlaysRef.current;
    const nextIds = new Set<string>();

    mapItems.forEach((item) => {
      const id =
        item.type === "single" ? String(item.property._id) : item.id;
      nextIds.add(id);

      const isActive =
        item.type === "single" && currentHoverID === item.property._id;

      const existing = registry.get(id);
      if (existing) {
        existing.setActive(isActive);
        return;
      }

      const price =
        item.type === "single"
          ? Math.round(
              Number(item.property.avgRatePerDay ?? item.property.base_price)
            )
          : item.minPrice;

      const handle = createPriceMarker(maps, {
        lat: item.lat,
        lng: item.lng,
        type: item.type,
        price,
        otherCount: item.type === "cluster" ? item.otherCount : undefined,
        active: isActive,
        onClick: () => {
          if (item.type === "single") {
            handleSetCenterLocation(item.lat, item.lng, item.property);
          } else {
            handleClusterClick(item);
          }
        },
      });
      handle.overlay.setMap(map);
      registry.set(id, handle);
    });

    // Remove overlays whose marker is no longer present.
    registry.forEach((handle, id) => {
      if (!nextIds.has(id)) {
        handle.overlay.setMap(null);
        registry.delete(id);
      }
    });
  }, [mapItems, currentHoverID, mapReady, handleSetCenterLocation, handleClusterClick]);

  // Tear down every overlay when the component unmounts.
  useEffect(() => {
    const registry = markerOverlaysRef.current;
    return () => {
      registry.forEach((handle) => handle.overlay.setMap(null));
      registry.clear();
    };
  }, []);

  const { city, filterState, updateFilterState, filterValues, setFilterValues,setResetFilter, resetFilter, setLocationCounts, setFilteredCount, filteredCount } = useAppContext()

  const cityCoordinates = [
    { lat: 50.85034, lng: 4.35171 },//city: "Brussels",
    { lat: 48.864716, lng: 2.349014 } //city: "Paris",
  ];

  const NEIGHBOURHOOD_ZOOM = 15;

  // Pan (and zoom) the map to a coordinate.
  const focusMapOn = (lat: number, lng: number, zoom: number) => {
    setSelectedCluster(null);
    setSelectedProperty(null);
    setCenterLocation({ lat, lng });
    const map = mapRef.current as any;
    if (map && map.setZoom) map.setZoom(zoom);
    setZoomLevel(zoom);
  };

  // Reorders (never filters) the current list so properties closest to
  // `center` come first. Properties without coordinates sort to the end
  // rather than being dropped, since this is a sort, not a filter.
  const sortByProximity = (list: Property[], center: { lat: number; lng: number }): Property[] => {
    const sqDistance = (property: Property): number => {
      const coords = getCoords(property);
      if (!coords) return Infinity;
      const dLat = coords.lat - center.lat;
      const dLng = coords.lng - center.lng;
      return dLat * dLat + dLng * dLng;
    };
    return [...list].sort((a, b) => sqDistance(a) - sqDistance(b));
  };

  const handleSelectNeighborhood = (city: string, area: NeighbourhoodArea) => {
    setSelectedNeighborhood(area.name);
    setNeighborhoodsOpen(false);
    setCurrentPage(1);
    const currentCity = filterState?.location || "Paris";
    if (city !== currentCity) {
      // Switch city first; the map reloads and re-centres, so defer the
      // neighbourhood focus (and the proximity sort) until the new listing
      // has finished loading.
      pendingCenterRef.current = { lat: area.lat, lng: area.lng };
      updateFilterState("location", city);
    } else {
      focusMapOn(area.lat, area.lng, NEIGHBOURHOOD_ZOOM);
      setFilterProperties((prev) => sortByProximity(prev, { lat: area.lat, lng: area.lng }));
    }
  };

  const handleResetNeighborhood = () => {
    setSelectedNeighborhood(null);
    setNeighborhoodsOpen(false);
    const currentCity = filterState?.location || "Paris";
    const center = CITY_CENTERS[currentCity] || CITY_CENTERS.Paris;
    focusMapOn(center.lat, center.lng, 13);
    // Drop the proximity sort and go back to the normal (filtered, unsorted
    // by distance) order.
    applyFilters(filterValues);
  };

  // After a city switch triggered from the neighbourhood dropdown, wait for the
  // new listing to load and then focus the map on the chosen neighbourhood and
  // sort the newly-loaded properties by proximity to it.
  useEffect(() => {
    if (!loading && pendingCenterRef.current) {
      const target = pendingCenterRef.current;
      pendingCenterRef.current = null;
      focusMapOn(target.lat, target.lng, NEIGHBOURHOOD_ZOOM);
      setFilterProperties((prev) => sortByProximity(prev, target));
    }
  }, [loading]);

  // When the selected city changes, drop any neighbourhood selection so the
  // dropdown label doesn't show an area from the other city.
  useEffect(() => {
    setSelectedNeighborhood(null);
    setNeighborhoodsOpen(false);
  }, [filterState?.location]);

  // AI search "near <place>": resolve the known area's coordinates and queue the
  // same map-focus + closest-first sort the neighbourhood dropdown uses. The
  // queued focus is consumed once the (re)fetch triggered by the same search
  // finishes — see the [loading] effect above. This only fires when the AI's
  // `nearbyArea` changes; manual dropdown picks don't touch it, so they're
  // unaffected. A later search with no "near" target clears the selection.
  useEffect(() => {
    const area = filterState?.nearbyArea;
    const place = filterState?.nearbyPlace;

    // The hardcoded table wins when it has the name: those coordinates are
    // exact and reviewed, where nearbyPlace's come from the model. nearbyPlace
    // is the fallback that covers everywhere else — the Musée d'Orsay, Père
    // Lachaise, Canal Saint-Martin — which previously resolved to nothing and
    // silently degraded into an unsorted city-wide search.
    const known = area ? findAreaCoords(area) : null;
    const coords = known || (place ? { lat: place.lat, lng: place.lng } : null);
    const label = (known ? area : place?.name) ?? null;

    if (!coords) {
      setSelectedNeighborhood(null);
      return;
    }
    setCurrentPage(1);
    setSelectedNeighborhood(label);
    pendingCenterRef.current = { lat: coords.lat, lng: coords.lng };
    // Depends on the primitive fields rather than the nearbyPlace object, whose
    // identity changes on every search even when the target is unchanged.
  }, [
    filterState?.nearbyArea,
    filterState?.nearbyPlace?.name,
    filterState?.nearbyPlace?.lat,
    filterState?.nearbyPlace?.lng,
  ]);

  // Close the neighbourhood dropdown when clicking outside of it.
  useEffect(() => {
    if (!neighborhoodsOpen) return;
    const onDocClick = (e: MouseEvent) => {
      if (neighborhoodsRef.current && !neighborhoodsRef.current.contains(e.target as Node)) {
        setNeighborhoodsOpen(false);
      }
    };
    document.addEventListener("mousedown", onDocClick);
    return () => document.removeEventListener("mousedown", onDocClick);
  }, [neighborhoodsOpen]);

  const formattedFilterState = {
    ...filterState,
    // This object is both the API query and what gets cached into the
    // "filterData" sessionStorage blob, so it must hold canonical strings.
    checkInDate: toFilterDateString(filterState?.checkInDate),
    checkOutDate: toFilterDateString(filterState?.checkOutDate),
  };
  const fetchProperties = async (values: any) => {
    try {
      const { number_of_pets, location, ...restFilterState } = formattedFilterState as any;
      const effectiveCity = location || null;
      const pData = {
        ...values,
        ...restFilterState,
        ...(number_of_pets ? { number_of_pets } : {}),
        ...(effectiveCity ? { location: effectiveCity, city: effectiveCity } : {}),
        page: currentPage,
        limit: 10
      }
      setLoading(true);
      sessionStorage.setItem('filterData', JSON.stringify(pData));
      const response = await axios.get<ApiResponse>(`${base_url}/property/website_property_listing`, {
        params: pData,
      });
      updateFilterState("handleSubmit", false)
      if (response.data.error) {
        setSnackbarSeverity('error');
        setSnackbarMessage(response.data.title);
        return setSnackbarOpen(true);
      }
      const updatedProperties = response.data.data.map((property: any) => {
        // `image` is usually a URL string, but some properties store an array of
        // them — flatten either shape and drop anything that isn't a usable URL,
        // otherwise the cards call .replace() on a non-string and crash.
        const toUrls = (value: any): string[] =>
          (Array.isArray(value) ? value.flat(Infinity) : [value]).filter(
            (url: any): url is string => typeof url === "string" && !!url
          );

        const coverImages = toUrls(property.galleryImgs);
        // No cover images picked in DMS yet — fall back to the property's single
        // legacy image field so the card isn't blank

        const updatedGalleryImages = coverImages.length > 0 ? coverImages : toUrls(property.image);

        return { ...property, galleryImgs: updatedGalleryImages };
      });

      setProperties(updatedProperties);
      // Route through applyFilters (passing the fresh list explicitly, since
      // `properties` state hasn't updated yet in this closure) rather than
      // setting the raw list directly — otherwise an in-progress rules/
      // amenities/etc. selection from `values` gets silently dropped the
      // moment location/dates/guests trigger a refetch.
      applyFilters(values, updatedProperties);
      // Compute per-city counts from the same dataset
      const counts: Record<string, number> = {};
      updatedProperties.forEach((p: any) => {
        const loc = (p.location || p.city || "").toLowerCase();
        if (loc) {
          const key = loc.charAt(0).toUpperCase() + loc.slice(1);
          counts[key] = (counts[key] || 0) + 1;
        }
      });
      setLocationCounts((prev: Record<string, number>) => ({ ...prev, ...counts }));
      if (filterState?.location === "Paris") {
        setCenterLocation({ lat: 48.864716, lng: 2.349014 });
      } else if (filterState?.location === "Brussels") {
        setCenterLocation({ lat: 50.85034, lng: 4.35171 });
      } else {
        // No location selected — default to Paris view
        setCenterLocation({ lat: 48.864716, lng: 2.349014 });
      }
    } catch (err: any) {
      setError(err.response?.data?.message || 'Failed to fetch properties');
    } finally {
      setLoading(false);
      updateFilterState("handleSubmit", false)
    }
  };


  // Stays option ids — must match STAY_TYPES in MoreFiltersPanel
  const STAY_ANY = "travel";
  const STAY_1M = "residential_1m";
  const STAY_3M = "residential_3m";

  // status_of_unit / type_of_unit are free-text and stored inconsistently
  // ("Secondary residence" vs "Secondary-residence"), so compare normalized.
  const normalizeUnitValue = (value: string) =>
    (value || "").toLowerCase().replace(/[-_]+/g, " ").replace(/\s+/g, " ").trim();

  // Which Stays options a property qualifies for, from its city + unit fields.
  const getStayOptionsForProperty = (property: any): string[] => {
    const city = (property.location || property.city || "").toLowerCase();
    const status = normalizeUnitValue(property.status_of_unit);

    const isSecondary = status === "secondary residence";

    if (city.includes("brussels")) {
      return isSecondary ? [STAY_3M] : [STAY_1M, STAY_ANY];
    }

    // Paris, and any other/unknown city
    if (isSecondary) return [STAY_1M, STAY_3M];
    // Primary, Hospitality, and anything unclassified (many properties have no
    // unit fields set) all fall through to "any duration" — mirrors Brussels,
    // and stops missing unit data from silently hiding a property.
    return [STAY_ANY];
  };

  // Property Type buckets — ids match PROPERTY_TYPES in MoreFiltersPanel.
  // "Airbnb" follows the "Airbnb Type Activity" card in the DMS Business Overview
  // (europea-api controllers/booking.js, activity_type_property1), but reads
  // status_of_unit / type_of_unit instead of that card's residence_type, which is
  // legacy and only populated on older properties. Per the card, Paris counts only
  // primary residences while Brussels counts secondary ones too.
  const propertyTypeMatchers: Record<string, (property: any) => boolean> = {
    Airbnb: (property: any) => {
      const city = (property.location || property.city || "").toLowerCase();
      const status = normalizeUnitValue(property.status_of_unit);
      if (normalizeUnitValue(property.type_of_unit) !== "residential") return false;
      return city.includes("brussels")
        ? status === "primary residence" || status === "secondary residence"
        : status === "primary residence";
    },
    // type_of_unit splits hospitality across two values
    "Hotel / Apart-hotel": (property: any) => {
      const unitType = normalizeUnitValue(property.type_of_unit);
      return unitType === "hotel / apart hotel" || unitType === "hospitality";
    },
    Residential: (property: any) => normalizeUnitValue(property.type_of_unit) === "residential",
  };

  // Property Rules live on two different property fields — ids match PROPERTY_RULES
  // in MoreFiltersPanel, values are the ones actually stored on the property.
  const propertyRuleMatchers: Record<string, { field: string; values: string[] }> = {
    "Pets allowed": { field: "policies", values: ["Pets allowed", "Pets accepted under request"] },
    "Family Friendly": { field: "accessibility", values: ["Family friendly"] },
    "Smoking allowed": { field: "policies", values: ["Smoking allowed"] },
  };

  const propertyMatchesRule = (property: any, rule: string): boolean => {
    const matcher = propertyRuleMatchers[rule];
    if (!matcher) return false;
    const stored: string[] = property[matcher.field] || [];
    return stored.some((entry: string) =>
      matcher.values.some((want) => normalizeUnitValue(entry) === normalizeUnitValue(want))
    );
  };

  // `sourceProperties` defaults to the current `properties` state so existing
  // callers (triggered by a filterValues change alone) behave exactly as
  // before. `fetchProperties` passes its freshly-fetched list explicitly,
  // since `properties` state wouldn't be updated yet at the point it needs to
  // filter — see the comment there.
  const applyFilters = (filterValues: any, sourceProperties: any[] = properties) => {
    const rangePrices = filterValues.rangePrices
    const filteredProperties = sourceProperties.filter((property) => {
      const matchesToilets = filterValues.toilets === 0 || property.toilets >= filterValues.toilets;
      const matchesBedrooms = filterValues.bedrooms === 0 || property.bedrooms >= filterValues.bedrooms;
      const matchesBathrooms = filterValues.bathrooms === 0 || property.bathrooms >= filterValues.bathrooms;

      let matchesPriceRange
      if (property.avgRatePerDay) {
        matchesPriceRange = property.avgRatePerDay >= rangePrices[0] && property.avgRatePerDay <= rangePrices[1];
      } else {
        matchesPriceRange = property.base_price >= rangePrices[0] && property.base_price <= rangePrices[1];
      }

      const selectedTypes: string[] = filterValues.propertyType || [];
      let matchesPropertyType = true;
      if (selectedTypes.length > 0) {
        // Buckets overlap (a property can be both Airbnb and Residential), so a
        // property qualifies if it falls in any selected bucket.
        matchesPropertyType = selectedTypes.some((type: string) =>
          propertyTypeMatchers[type] ? propertyTypeMatchers[type](property) : false
        );
      }

      const selectedAmenities: string[] = filterValues.amenities || [];
      let matchesAmenities = true;
      if (selectedAmenities.length > 0) {
        matchesAmenities = selectedAmenities.every((am: string) =>
          property.amenities?.some((item: any) => item.name?.toLowerCase().includes(am.toLowerCase()))
        );
      }

      const selectedRules: string[] = filterValues.propertyRules || [];
      let matchesPropertyRules = true;
      if (selectedRules.length > 0) {
        matchesPropertyRules = selectedRules.every((rule: string) =>
          propertyMatchesRule(property, rule)
        );
      }

      const selectedStayTypes: string[] = filterValues.stayTypes || [];
      let matchesStayType = true;
      if (selectedStayTypes.length > 0) {
        const stayOptions = getStayOptionsForProperty(property);
        matchesStayType = selectedStayTypes.some((st: string) => stayOptions.includes(st));
      }

      const selectedSafety: string[] = filterValues.safetyMeasures || [];
      let matchesSafety = true;
      if (selectedSafety.length > 0) {
        matchesSafety = selectedSafety.every((sm: string) =>
          property.security_and_safety?.some((item: string) => item.toLowerCase() === sm.toLowerCase())
        );
      }

      return (
        matchesToilets &&
        matchesBedrooms &&
        matchesBathrooms &&
        matchesPriceRange &&
        matchesPropertyType &&
        matchesAmenities &&
        matchesSafety &&
        matchesStayType &&
        matchesPropertyRules
      );
    });

    // Property rules are filtered above, so no rules-based sort is needed here —
    // every remaining property already matches every selected rule.
    const sorted = filteredProperties;

    setFilterProperties(sorted);
    setFilteredCount(sorted.length);
    setTotalPages(Math.ceil(sorted.length / 10));
  };

  // A `[loading]`-keyed effect used to live here, re-applying filters from
  // sessionStorage("filterValues") every time a fetch finished. Its only
  // writer (TabFilterNew.tsx) isn't rendered anywhere in the current app, so
  // that key is never kept in sync with live filterValues — its stored/default
  // shape doesn't even include propertyRules/amenities/safetyMeasures/
  // stayTypes. Every fetch completion (loading true->false) fired it, which
  // silently reset those filters to "match everything" right after
  // fetchProperties had just correctly applied them. Removed rather than
  // fixed: applyFilters already runs off live filterValues both here (via the
  // filterValues-watching effect below) and inside fetchProperties, so this
  // was a redundant, stale-data path rather than a needed one.

  useEffect(() => {
    const storedFilters = sessionStorage.getItem("selectedFilters");
    if (storedFilters) {
      setSelectedFilters(JSON.parse(storedFilters));
    }
  }, [totalPages]);

  const handleSnackbarClose = () => {
    setSnackbarOpen(false);
  };

  const sortProperties = (filters: string[]) => {
    let sortedProperties = [...filterproperties]
    sortedProperties = sortedProperties.sort((a: any, b: any) => a.rank - b.rank);
    if (filters?.includes("Pets Allowed")) {
      sortedProperties = sortedProperties.sort((a: any, b: any) => {
        const aAllowsPets = a?.policies?.includes("Pets allowed") ? 1 : 0;
        const bAllowsPets = b?.policies?.includes("Pets allowed") ? 1 : 0;

        return bAllowsPets - aAllowsPets;
      });
    }

    if (filters?.includes('Family friendly')) {
      sortedProperties = sortedProperties.sort((a: any, b: any) => {
        const aAllowsPets = a?.accessibility?.includes('Family friendly') ? 1 : 0;
        const bAllowsPets = b?.accessibility?.includes('Family friendly') ? 1 : 0;

        return bAllowsPets - aAllowsPets;
      });
    }
    if (filters?.includes('Pets friendly')) {
      sortedProperties = sortedProperties.sort((a: any, b: any) => {
        const aAllowsPets = a?.accessibility?.includes('Pets friendly') ? 1 : 0;
        const bAllowsPets = b?.accessibility?.includes("Pets friendly") ? 1 : 0;

        return bAllowsPets - aAllowsPets;
      });
    } if (filters?.includes('Middle term stay')) {
      sortedProperties = sortedProperties.sort((a: any, b: any) => {
        const aAllowsPets = a?.accessibility?.includes('Middle term stay') ? 1 : 0;
        const bAllowsPets = b?.accessibility?.includes("Middle term stay") ? 1 : 0;

        return bAllowsPets - aAllowsPets;
      });
    }
    setFilterProperties(sortedProperties);
  };

  useEffect(() => {
    sortProperties(selectedFilters)
  }, [selectedFilters])


  useEffect(() => {
    if (filterState?.handleSubmit) {
      fetchProperties(filterValues);
    }
  }, [filterState?.handleSubmit]);

  useEffect(() => {
    fetchProperties(filterValues);
    // Infants and pets are deliberately excluded: infants must not affect the
    // results, and the pets guest option has been removed from search. Adults
    // (guestNumber) and children both refresh the listing.
  }, [
    filterState?.location,
    filterState?.checkInDate,
    filterState?.checkOutDate,
    filterState?.guestNumber,
    filterState?.number_of_children,
  ]);

  useEffect(() => {
    fetchProperties(filterValues);
  }, []);

  useEffect(() => {
    if (properties.length > 0) {
      applyFilters(filterValues);
    }
  }, [filterValues.rangePrices, filterValues.bedrooms, filterValues.bathrooms, filterValues.toilets, filterValues.propertyRules, filterValues.propertyType, filterValues.amenities, filterValues.safetyMeasures, filterValues.stayTypes]);

  const handlePageChange = (_event: React.ChangeEvent<unknown>, page: number) => {
    setCurrentPage(page);
    window.scrollTo({ top: 0, behavior: 'smooth' }); 
    const scrollContainer = document.querySelector('.overflow-y-auto');
    if (scrollContainer) {
      scrollContainer.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };


  const mapStyles4 = [
    {
      "elementType": "geometry",
      "stylers": [{ "color": "#e0e0e0" }] // Light gray background
    },
    {
      "elementType": "labels.text.fill",
      "stylers": [{ "color": "#616161" }] // Dark gray text
    },
    {
      "elementType": "labels.text.stroke",
      "stylers": [{ "color": "#f5f5f5" }] // White text stroke
    },
    {
      "featureType": "water",
      "elementType": "geometry",
      "stylers": [{ "color": "#add8e6" }] // Light blue for water
    },
    {
      "featureType": "landscape",
      "elementType": "geometry",
      "stylers": [{ "color": "#f9f9f9" }] // Light gray for general land
    },
    {
      "featureType": "poi.park",
      "elementType": "geometry",
      "stylers": [{ "color": "#c5e1a5" }] // Light green for parks
    },
    {
      "featureType": "poi",
      "elementType": "geometry",
      "stylers": [{ "color": "#d6d6d6" }] // Gray for points of interest
    },
    {
      "featureType": "road",
      "elementType": "geometry",
      "stylers": [{ "color": "#ffffff" }] // White roads
    }
  ];
  const mapStyles = [
    {
      "elementType": "geometry",
      "stylers": [{ "color": "#F6F6F4" }]
    },
    {
      "elementType": "labels.text.fill",
      "stylers": [{ "color": "#523735" }]
    },
    {
      "elementType": "labels.text.stroke",
      "stylers": [{ "color": "#f5f1e6" }]
    },
    {
      "featureType": "water",
      "elementType": "geometry",
      "stylers": [{ "color": "#D0ECEF" }]
    },
    {
      "featureType": "landscape.natural",
      "elementType": "geometry",
      "stylers": [{ "color": "#F6F6F4" }]
    },
    {
      "featureType": "poi.park",
      "elementType": "geometry",
      "stylers": [{ "color": "#E2F2DA" }]
    },
    {
      "featureType": "road",
      "elementType": "geometry",
      "stylers": [{ "color": "#ffffff" }]
    },
    {
      "featureType": "administrative",
      "elementType": "labels.text.fill",
      "stylers": [{ "color": "#444444" }]
    },
    {
      featureType: "administrative",
      elementType: "geometry",
      stylers: [
        {
          color: "#e0e0e0",
        },
      ],
    },
    { "elementType": "labels.text.fill", "stylers": [{ "color": "#4a4a4a", "fontWeight": "bold" }] },
  ]

  const mapStyles2 = [
    {
      "elementType": "geometry",
      "stylers": [{ "color": "#f5f5f5" }]
    },
    {
      "elementType": "labels.text.fill",
      "stylers": [{ "color": "#616161" }]
    },
    {
      "elementType": "labels.text.stroke",
      "stylers": [{ "color": "#f5f5f5" }]
    },
    {
      "featureType": "administrative",
      "elementType": "geometry",
      "stylers": [{ "color": "#e4c7c7" }] // Light red for borders
    },
    {
      "featureType": "administrative.land_parcel",
      "elementType": "labels.text.fill",
      "stylers": [{ "color": "#d2a600" }] // Yellow text
    },
    {
      "featureType": "landscape.man_made",
      "elementType": "geometry",
      "stylers": [{ "color": "#eaeaea" }]
    },
    {
      "featureType": "landscape.natural",
      "elementType": "geometry",
      "stylers": [{ "color": "#d5f5d1" }] // Light green parks/vegetation
    },
    {
      "featureType": "poi",
      "elementType": "geometry",
      "stylers": [{ "color": "#eeeeee" }]
    },
    {
      "featureType": "poi.park",
      "elementType": "geometry",
      "stylers": [{ "color": "#bdecb6" }] // Light green parks
    },
    {
      "featureType": "road",
      "elementType": "geometry",
      "stylers": [{ "color": "#ffffff" }]
    },
    {
      "featureType": "road.arterial",
      "elementType": "labels.text.fill",
      "stylers": [{ "color": "#757575" }]
    },
    {
      "featureType": "road.highway",
      "elementType": "geometry",
      "stylers": [{ "color": "#dadada" }]
    },
    {
      "featureType": "road.highway",
      "elementType": "labels.text.fill",
      "stylers": [{ "color": "#616161" }]
    },
    {
      "featureType": "transit",
      "elementType": "geometry",
      "stylers": [{ "color": "#e5e5e5" }]
    },
    {
      "featureType": "water",
      "elementType": "geometry",
      "stylers": [{ "color": "#c9c9c9" }]
    },
    {
      "featureType": "water",
      "elementType": "labels.text.fill",
      "stylers": [{ "color": "#9e9e9e" }]
    }
  ]

  // Snazzy Maps — Flat Pale (https://snazzymaps.com/style/14889/flat-pale)
  const mapStyles1 = [
    { featureType: "administrative", elementType: "labels.text.fill", stylers: [{ color: "#6195a0" }] },
    { featureType: "administrative.province", elementType: "geometry.stroke", stylers: [{ visibility: "off" }] },
    { featureType: "landscape", elementType: "geometry", stylers: [{ lightness: "0" }, { saturation: "0" }, { color: "#F7F1DF" }, { gamma: "1" }] },
    { featureType: "landscape.man_made", elementType: "all", stylers: [{ lightness: "-3" }, { gamma: "1.00" }] },
    { featureType: "landscape.natural.terrain", elementType: "all", stylers: [{ visibility: "off" }] },
    { featureType: "poi", elementType: "all", stylers: [{ visibility: "off" }] },
    { featureType: "poi.park", elementType: "geometry.fill", stylers: [{ color: "#bae5ce" }, { visibility: "on" }] },
    { featureType: "road", elementType: "all", stylers: [{ saturation: -100 }, { lightness: 45 }, { visibility: "simplified" }] },
    { featureType: "road.highway", elementType: "all", stylers: [{ visibility: "simplified" }] },
    { featureType: "road.highway", elementType: "geometry.fill", stylers: [{ color: "#fac9a9" }, { visibility: "simplified" }] },
    { featureType: "road.highway", elementType: "labels.text", stylers: [{ color: "#4e4e4e" }] },
    { featureType: "road.arterial", elementType: "labels.text.fill", stylers: [{ color: "#787878" }] },
    { featureType: "road.arterial", elementType: "labels.icon", stylers: [{ visibility: "off" }] },
    { featureType: "transit", elementType: "all", stylers: [{ visibility: "simplified" }] },
    { featureType: "transit.station.airport", elementType: "labels.icon", stylers: [{ hue: "#0a00ff" }, { saturation: "-77" }, { gamma: "0.57" }, { lightness: "0" }] },
    { featureType: "transit.station.rail", elementType: "labels.text.fill", stylers: [{ color: "#43321e" }] },
    { featureType: "transit.station.rail", elementType: "labels.icon", stylers: [{ hue: "#ff6c00" }, { lightness: "4" }, { gamma: "0.75" }, { saturation: "-68" }] },
    { featureType: "water", elementType: "all", stylers: [{ color: "#eaf6f8" }, { visibility: "on" }] },
    { featureType: "water", elementType: "geometry.fill", stylers: [{ color: "#c7eced" }] },
    { featureType: "water", elementType: "labels.text.fill", stylers: [{ lightness: "-49" }, { saturation: "-53" }, { gamma: "0.79" }] },
  ];

  const handleApiLoaded = ({ map, maps }: { map: google.maps.Map; maps: any }) => {
    mapRef.current = map as google.maps.Map;
    mapsRef.current = maps;
    setMapReady(true);
    // If a programmatic centerLocation was set before the map finished loading
    // (e.g. a city switch), sync the map to it now — the panTo effect above
    // no-ops while mapRef is still null.
    (map as any).panTo?.(centerLocation);
  };
    const handleClose = () => {
    setOpen(false);
    setFormValues({
      name: "",
      email: "",
      phone: "",
      message: "",
      isChecked: false
    })
  }

  return (
    <div>
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={6000}
        onClose={handleSnackbarClose}
      >
        <Alert onClose={handleSnackbarClose} severity={snackbarSeverity}>
          {snackbarMessage}
        </Alert>
      </Snackbar>
      {/* Two-panel layout */}
      <div className="relative flex flex-col xl:flex-row gap-[20px] px-4 sm:px-6 lg:px-[40px] mt-[24px]">
        {/* LEFT PANEL — Map */}
        <div
          className={`${
            showFullMapFixed ? "fixed inset-0 z-50 bg-white p-3 flex flex-col" : "hidden"
          } h-screen xl:h-[calc(100vh-114px)] xl:flex xl:static xl:inset-auto xl:z-auto xl:bg-transparent xl:p-0 xl:sticky xl:top-[90px] xl:self-start flex-shrink-0 ${
            mapExpanded ? "xl:w-full" : "xl:w-[468px]"
          }`}
        >
          {showFullMapFixed && (
            <button
              onClick={() => {
                setShowFullMapFixed(false);
                setMapExpanded(false);
                setSelectedProperty(null);
                setSelectedCluster(null);
              }}
              className="xl:hidden flex items-center gap-[8px] mb-3 self-start px-[14px] h-[38px] rounded-[6px] bg-white border border-solid border-[#d6d6d6] cursor-pointer flex-shrink-0"
            >
              <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
                <path d="M9 1L2 7L9 13" stroke="#01152E" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
              <span
                className="text-[14px] leading-[24px] text-[#01152E]"
                style={{ fontFamily: "Poppins, sans-serif", fontWeight: 500 }}
              >
                {t("common.backToSearch")}
              </span>
            </button>
          )}
          <div className="map-container relative rounded-[6px] overflow-clip w-full h-full flex-1 min-h-0" style={{ border: "1px solid #d6d6d6", outline: "none" }}>
            {/* Top gradient fade */}
            <div
              className="absolute top-0 left-0 right-0 h-[60px] z-10 pointer-events-none rounded-t-[7px]"
              style={{ background: "linear-gradient(to bottom, #f7f3ec, rgba(246,246,245,0))" }}
            />

            {/* Map overlay — city name + property count */}
            <div className="absolute top-[16px] left-[16px] z-20 pointer-events-none flex flex-col max-w-[45%] sm:max-w-none">
              {/* Back to search — only in the expanded (wide) map. The minimize
                  icon alone wasn't an obvious way back, so this is a clearly
                  labelled control that collapses the map and restores the list. */}
              {mapExpanded && (
                <button
                  onClick={() => {
                    setMapExpanded(false);
                    setSelectedProperty(null);
                  }}
                  className="pointer-events-auto self-start hidden xl:flex items-center gap-[8px] mb-[12px] px-[14px] h-[38px] rounded-[6px] bg-white border border-solid border-[#d6d6d6] cursor-pointer"
                >
                  <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
                    <path d="M9 1L2 7L9 13" stroke="#01152E" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                  </svg>
                  <span
                    className="text-[14px] leading-[24px] text-[#01152E] whitespace-nowrap"
                    style={{ fontFamily: "Poppins, sans-serif", fontWeight: 500 }}
                  >
                    {t("common.backToSearch")}
                  </span>
                </button>
              )}
              <p
                className="text-[20px] leading-[24px] text-[#01152E] m-0"
                style={{ fontFamily: "Poppins, sans-serif", fontWeight: 500 }}
              >
                {filterState?.location || "Paris"}
              </p>
              <p
                className="text-[12px] leading-[16px] sm:leading-[24px] text-[#01152E] m-0 mt-[4px] uppercase tracking-[1.2px]"
                style={{ fontFamily: "Poppins, sans-serif", fontWeight: 500 }}
              >
                {filteredCount} {filteredCount === 1 ? t("common.property") : t("common.properties")}
                <span className="hidden sm:inline"> · </span>
                <br className="sm:hidden" />
                {t("listingStay.liveMap")}
              </p>
            </div>

            {/* Map overlay — Neighborhoods dropdown */}
            <div ref={neighborhoodsRef} className="absolute top-[16px] right-[54px] z-30">
              <button
                onClick={() => setNeighborhoodsOpen((prev) => !prev)}
                className="flex items-center gap-[10px] h-[38px] px-[12px] sm:px-[16px] bg-white border border-solid border-[#d6d6d6] rounded-[6px] cursor-pointer max-w-[140px] sm:max-w-[240px]"
              >
                <span
                  className="text-[14px] leading-[24px] text-[#01152E] whitespace-nowrap overflow-hidden text-ellipsis"
                  style={{ fontFamily: "Poppins, sans-serif", fontWeight: 500 }}
                >
                  {selectedNeighborhood || t("listingStay.neighborhoods")}
                </span>
                <svg
                  width="14"
                  height="8"
                  viewBox="0 0 14 8"
                  fill="none"
                  style={{
                    transform: neighborhoodsOpen ? "rotate(180deg)" : "none",
                    transition: "transform 0.15s ease",
                    flexShrink: 0,
                  }}
                >
                  <path d="M1 1L7 7L13 1" stroke="#01152E" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
              </button>

              {neighborhoodsOpen && (
                <div
                  className="absolute top-[46px] right-0 w-[248px] max-h-[360px] overflow-y-auto bg-white border border-solid border-[#d6d6d6] rounded-[8px] py-[6px]"
                  style={{ boxShadow: "0 8px 24px rgba(9, 66, 84, 0.16)" }}
                >
                  <button
                    onClick={handleResetNeighborhood}
                    className="w-full text-left px-[16px] py-[8px] text-[14px] cursor-pointer bg-white hover:bg-[#f2f2f0] border-0"
                    style={{ fontFamily: "Poppins, sans-serif", fontWeight: 500, color: "#01152E" }}
                  >
                    {t("listingStay.showAllNeighbourhoods")}
                  </button>
                  {NEIGHBOURHOODS.filter(
                    (group) => group.city === (filterState?.location || "Paris")
                  ).map((group) => (
                    <div key={group.city}>
                      <p
                        className="px-[16px] pt-[10px] pb-[4px] m-0 text-[12px] uppercase tracking-[1px]"
                        style={{ fontFamily: "Poppins, sans-serif", fontWeight: 600, color: "#7a8a90" }}
                      >
                        {group.city}
                      </p>
                      {group.areas.map((area) => (
                        <button
                          key={area.name}
                          onClick={() => handleSelectNeighborhood(group.city, area)}
                          className={`w-full text-left px-[16px] py-[8px] text-[14px] cursor-pointer border-0 hover:bg-[#f2f2f0] ${
                            selectedNeighborhood === area.name ? "bg-[#eef3f4]" : "bg-white"
                          }`}
                          style={{ fontFamily: "Poppins, sans-serif", fontWeight: 500, color: "#01152E" }}
                        >
                          {area.name}
                        </button>
                      ))}
                    </div>
                  ))}
                </div>
              )}
            </div>

            {/* Map overlay — zoom/fullscreen controls */}
            <div className="absolute top-[16px] right-[10px] z-20 flex flex-col gap-[8px]">
              {/* Fullscreen / Minimize */}
              <button
                onClick={() => {
                  setMapExpanded((prev) => {
                    if (prev) setSelectedProperty(null);
                    return !prev;
                  });
                }}
                className="flex items-center justify-center w-[38px] h-[38px] rounded-[6px] bg-white border border-solid border-[#d6d6d6] cursor-pointer p-0"
              >
                {mapExpanded ? (
                  <img src={minimizeIcon} alt={t("listingStay.minimize")} width={14} height={14} />
                ) : (
                  <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
                    <path d="M1 5V1H5" stroke="#01152E" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                    <path d="M13 5V1H9" stroke="#01152E" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                    <path d="M1 9V13H5" stroke="#01152E" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                    <path d="M13 9V13H9" stroke="#01152E" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                  </svg>
                )}
              </button>
              {/* Zoom in */}
              <button
                onClick={() => {
                  const map = mapRef.current as any;
                  if (map) map.setZoom((map.getZoom() || 13) + 1);
                }}
                className="flex items-center justify-center w-[38px] h-[38px] rounded-[6px] bg-white border border-solid border-[#d6d6d6] cursor-pointer p-0"
              >
                <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
                  <path d="M7 1V13" stroke="#01152E" strokeWidth="1.5" strokeLinecap="round" />
                  <path d="M1 7H13" stroke="#01152E" strokeWidth="1.5" strokeLinecap="round" />
                </svg>
              </button>
              {/* Zoom out */}
              <button
                onClick={() => {
                  const map = mapRef.current as any;
                  if (map) map.setZoom((map.getZoom() || 13) - 1);
                }}
                className="flex items-center justify-center w-[38px] h-[38px] rounded-[6px] bg-white border border-solid border-[#d6d6d6] cursor-pointer p-0"
              >
                <svg width="14" height="2" viewBox="0 0 14 2" fill="none">
                  <path d="M1 1H13" stroke="#01152E" strokeWidth="1.5" strokeLinecap="round" />
                </svg>
              </button>
            </div>

            {/* Map overlay — cluster: list + property card side by side */}
            {mapExpanded && selectedCluster && (
              <div className="absolute top-[104px] sm:top-[80px] xl:top-[62px] left-[12px] right-[12px] xl:left-auto xl:right-[56px] z-20 flex flex-col xl:flex-row items-stretch xl:items-start gap-[12px] max-h-[calc(100%-116px)] sm:max-h-[calc(100%-92px)] xl:max-h-[calc(100%-74px)] overflow-y-auto">
                <ClusterPropertyList
                  properties={selectedCluster.properties}
                  location={filterState?.location || "Paris"}
                  selectedPropertyId={selectedProperty?._id}
                  maxHeight={cardHeight || undefined}
                  onSelectProperty={handleClusterPropertySelect}
                  onClose={() => {
                    setSelectedCluster(null);
                    setSelectedProperty(null);
                  }}
                />
                {selectedProperty && (
                  <div ref={cardRef}>
                    <MapPropertyCard
                      data={selectedProperty}
                      onClose={() => {
                        setSelectedCluster(null);
                        setSelectedProperty(null);
                      }}
                    />
                  </div>
                )}
              </div>
            )}

            {/* Map overlay — single property card (no cluster) */}
            {mapExpanded && selectedProperty && !selectedCluster && (
              <div className="absolute top-[104px] sm:top-[80px] xl:top-[62px] left-[12px] right-[12px] xl:left-auto xl:right-[56px] z-20 max-h-[calc(100%-116px)] sm:max-h-[calc(100%-92px)] xl:max-h-[calc(100%-74px)] overflow-y-auto">
                <MapPropertyCard
                  data={selectedProperty}
                  onClose={() => {
                    setSelectedProperty(null);
                    setMapExpanded(false);
                  }}
                />
              </div>
            )}

            <GoogleMapReact
              defaultZoom={13}
              defaultCenter={
                filterState?.location == "Paris"
                  ? cityCoordinates[1]
                  : cityCoordinates[0]
              }
              onGoogleApiLoaded={handleApiLoaded}
              bootstrapURLKeys={{
                key: "AIzaSyDE4YXJP-Oq9uXDySWbJBOBtwej5bdrw1A",
              }}
              yesIWantToUseGoogleMapApiInternals
              onChange={({ zoom }: { zoom: number; center: { lat: number; lng: number } }) => {
                // The map is uncontrolled for panning (no `center` prop) — we
                // recenter imperatively via mapRef.panTo in an effect. That
                // removes the old per-frame `setCenterLocation` write, which
                // re-rendered the whole component (and google-map-react's
                // marker layer) on every drag frame and made the price pills
                // blink. Only react to a real zoom change here, which is the
                // only thing that must re-cluster the markers.
                const nextZoom = Math.round(zoom);
                if (nextZoom !== zoomLevel) {
                  setZoomLevel(nextZoom);
                  setSelectedCluster(null);
                  setSelectedProperty(null);
                }
              }}
              onClick={() => {
                setSelectedCluster(null);
                setSelectedProperty(null);
              }}
              options={{
                styles: mapStyles1,
                gestureHandling: "cooperative",
                scrollwheel: false,
                fullscreenControl: false,
                mapTypeId: "roadmap",
                disableDefaultUI: true,
                zoomControl: false,
                clickableIcons: false,
              }}
            >
              {/* Price/cluster pills are rendered as native google.maps
                  overlays (see the marker-sync effect + priceMarkerOverlay.ts),
                  not as google-map-react children, so they stay glued to the
                  map while dragging instead of lagging behind it. */}
            </GoogleMapReact>
          </div>
        </div>

        {/* RIGHT PANEL — Cards */}
        <div className={`flex-1 min-w-0 ${mapExpanded ? "hidden" : ""}`}>
          {filterproperties && filterproperties.length > 0 ? (
            <div
              className={`grid gap-x-[20px] gap-y-8 ${
                smallScreen1 ? "grid-cols-1" : "grid-cols-2"
              }`}
            >
              {/* Only mount the cards while the list is actually visible. This
                  panel is CSS-hidden (display:none) when the map is expanded,
                  and each card's Glide image carousel measures its container
                  width when it initializes — mounting while hidden gives it a
                  0px width it never recovers from, leaving broken/imageless
                  cards after "Back to search". Gating on !mapExpanded means the
                  cards (and Glide) always initialize in a visible container,
                  even after the neighbourhood sort reorders the list. */}
              {!mapExpanded &&
                getPaginatedProperties().map((item: any) => (
                  <div
                    key={item._id}
                    onMouseEnter={() => setCurrentHoverID((_) => item._id)}
                    onMouseLeave={() => setCurrentHoverID((_) => -1)}
                  >
                    <PropertyCardEuropea id={item._id} data={item} />
                  </div>
                ))}
            </div>
          ) : (
            <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", gap: 16, height: "100%", minHeight: 500 }}>
              <img src={emptyStateIcon} alt="" style={{ width: 98, height: 84 }} />
              <p
                style={{
                  fontFamily: "Poppins, sans-serif",
                  fontWeight: 600,
                  fontSize: 20,
                  lineHeight: "24px",
                  color: "#01152E",
                  textAlign: "center",
                  margin: 0,
                }}
              >
                {t("listingStay.noMatches")}
              </p>
              <div
                style={{
                  fontFamily: "Roboto, sans-serif",
                  fontWeight: 400,
                  fontSize: 14,
                  lineHeight: "24px",
                  color: "#445162",
                  textAlign: "center",
                  margin: 0,
                }}
              >
                <p style={{ margin: 0 }}>{t("listingStay.noMatchesLine1")}</p>
                <p style={{ margin: 0 }}>{t("listingStay.noMatchesLine2")}</p>
                <p style={{ margin: 0 }}>{t("listingStay.noMatchesLine3")}</p>
              </div>
              <div style={{ display: "flex", gap: 30, alignItems: "center", marginTop: 8 }}>
                  <button
                    onClick={() => { setOpen(true); }}
                    style={{
                      fontFamily: "Poppins, sans-serif",
                      fontWeight: 600,
                      fontSize: 14,
                      lineHeight: "24px",
                      letterSpacing: "1.4px",
                      color: "#01152E",
                      textTransform: "uppercase",
                      textDecoration: "underline",
                      textUnderlineOffset: "3px",
                      background: "none",
                      border: "none",
                      cursor: "pointer",
                      padding: 0,
                    }}
                  >
                    {t("listingStay.sendMessage")}
                  </button>
                  <button
                    onClick={() => {
                      const defaults = { toilets: 0, bedrooms: 0, bathrooms: 0, propertyType: [] as string[], rangePrices: ["0", "1000"], propertyRules: [] as string[], amenities: [] as string[], safetyMeasures: [] as string[], stayTypes: [] as string[] };
                      setFilterValues(defaults);
                      sessionStorage.removeItem("filterValues");
                      sessionStorage.removeItem("selectedFilters");
                      setSelectedFilters([]);
                      applyFilters(defaults);
                    }}
                    style={{
                      fontFamily: "Poppins, sans-serif",
                      fontWeight: 600,
                      fontSize: 14,
                      lineHeight: "24px",
                      letterSpacing: "1.4px",
                      color: "#01152E",
                      textTransform: "uppercase",
                      textDecoration: "underline",
                      textUnderlineOffset: "3px",
                      background: "none",
                      border: "none",
                      cursor: "pointer",
                      padding: 0,
                    }}
                  >
                    {t("listingStay.clearFilters")}
                  </button>
              </div>
            </div>
          )}

          {currentPage * 10 < filterproperties.length ? (
            <div className="flex mt-[40px] justify-center items-center">
              <button
                onClick={() => setCurrentPage((p) => p + 1)}
                className="bg-white border border-[#d6d6d6] rounded-full px-[16px] h-[35px] flex items-center justify-center cursor-pointer hover:border-[#01152E] transition-colors"
              >
                <span
                  className="text-[14px] leading-[24px] text-[#01152E] whitespace-nowrap"
                  style={{ fontFamily: "Poppins, sans-serif", fontWeight: 500 }}
                >
                  {t("listingStay.loadMore")}
                </span>
              </button>
            </div>
          ) : filterproperties.length > 0 ? (
            <div className="flex flex-col sm:flex-row items-center sm:items-center text-center sm:text-left mt-[40px] gap-[20px] sm:gap-[60px]">
              <div className="flex-1 min-w-0 flex flex-col items-center sm:items-start gap-[10px]">
                <p
                  className="text-[16px] leading-[16px] text-[#01152E]"
                  style={{ fontFamily: "Poppins, sans-serif", fontWeight: 600 }}
                >
                  {t("listingStay.endOfCollection")}
                </p>
                <p
                  className="text-[12px] leading-[12px] text-[#445162]"
                  style={{ fontFamily: "Roboto, sans-serif", fontWeight: 400 }}
                >
                  {t("listingStay.refineSearch")}
                </p>
              </div>
              <button
                onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
                className="flex-shrink-0 bg-white border border-[#d6d6d6] rounded-full px-[16px] h-[35px] flex items-center justify-center gap-[9px] cursor-pointer hover:border-[#01152E] transition-colors"
              >
                <span
                  className="text-[14px] leading-[24px] text-[#01152E] whitespace-nowrap"
                  style={{ fontFamily: "Poppins, sans-serif", fontWeight: 500 }}
                >
                  {t("listingStay.backToTop")}
                </span>
                <img src={arrowUpIcon} alt="" className="w-[12px] h-[14px]" />
              </button>
            </div>
          ) : null}
          <ContactFormModal setSnackbarSeverity={setSnackbarSeverity}
                      setSnackbarMessage={setSnackbarMessage} setSnackbarOpen={setSnackbarOpen} formValues={formValues} setFormValues={setFormValues} isOpen={open} onClose={handleClose} />
        </div>

        {/* Mobile: show map button */}
        {!showFullMapFixed && (
          <div
            className="flex xl:hidden items-center justify-center fixed bottom-20 md:bottom-8 left-1/2 transform -translate-x-1/2 px-6 py-2 bg-neutral-900 text-white shadow-2xl rounded-full z-40 space-x-3 text-sm cursor-pointer whitespace-nowrap"
            onClick={() => setShowFullMapFixed(true)}
          >
            <i className="text-lg las la-map flex-shrink-0"></i>
            <span className="whitespace-nowrap">{t("listingStay.showMap")}</span>
          </div>
        )}
      </div>
    </div>
  );
};

export default SectionGridHasMap;
